import { log } from 'log';
import { extend } from 'underscore';
import { languageService } from '@core/js/services/language.service';

import { addParamsToUrl } from '@core/js/utils/url.util';

export {
    addParamsToUrl,
    getBaseDomain,
    getCleanPath,
    getCleanUrl,
    getCombinedSearch,
    getFriendlyUrl,
    getLang,
    getLocationParam,
    getLocationParams,
    getPartsUrl,
    getPathWithParams,
    getPathWithTrailingSlash,
    getSearchWithoutParameters,
    getURLParam,
    getURLParams,
    getUrlWithTrailingSlash,
    isDocumentsAndMediaUrl,
    isExternalUrl,
    isHashLink,
    isJavascriptURI,
    isLaunchGamePath,
    isParamPresent,
    openNewWindow,
    openWindow,
    parseUrl,
    redirect,
    serialize
} from '@core/js/utils/url.util';

export const addAllowedParamsToSrc = (src) => {
    try {
        // #region @theme
        if (src.includes('base64')) {
            return src;
        }
        // #endregion

        const search = new URLSearchParams(location.search);
        const casinoname = search.get('casinoname');
        const site = search.get('site');
        const allowedParams = {
            ...casinoname && { casinoname },
            ...site && { site }
        };

        return addParamsToUrl(allowedParams, src);
    } catch (error) {
        log('error', error);

        return '';
    }
};

// #region theme
export const formatURL = (url, params, escapingFunctionDefault) => {
    const placeholders = url.match(/[^{}]+(?=\})/g);
    let urlStr = url;

    const escapingFunction = escapingFunctionDefault || window.encodeURIComponent;

    if (!placeholders) {
        return urlStr;
    }

    if (params) {
        for (const param in params) {
            if (params[param]) {
                urlStr = urlStr.split(`{${param}}`).join(escapingFunction(params[param]));
            }
        }
    }

    return urlStr;
};

export const getFormattedUrl = (url, userData, options) => {
    const params = extend({}, userData, options);

    return formatURL(url, params);
};

export const getFormattedUrlAsync = async (url, userData, appData, getTempToken, deviceData, options = {}) => {
    const asyncParams = ['{tempToken}'];
    const foundAsyncParams = asyncParams.filter(param => url.includes(param));
    const promises = [];

    foundAsyncParams.forEach((param) => {
        switch (param) {
            case '{tempToken}': {
                promises.push(getTempToken().then(tempToken => tempToken?.data?.sessionToken?.sessionToken));

                break;
            }
            default: promises.push(true);
        }
    });

    return Promise.all(promises).then(results => {
        const additionalParams = {
            casinoName: appData.casinoName,
            clientSkin: appData.clientSkin,
            clientType: appData.clientType,
            clientVersion: appData.clientVersion,
            clientPlatform: deviceData.clientPlatform,
            lang: languageService.getTwoLetterLanguage(userData.lang)
        };

        foundAsyncParams.forEach((param, index) => {
            switch (param) {
                case '{tempToken}': additionalParams.tempToken = results[index]; break;
                default: additionalParams[param] = results[index];
            }
        });

        return getFormattedUrl(url, userData, {
            ...additionalParams,
            ...options
        });
    });
};

export const getIncrement = (value) => {
    if (isNaN(value) || value < 0) {
        return 0;
    }

    if (value < 50) {
        return 10;
    } else if (value >= 50 && value <= 500) {
        return 100;
    } else if (value > 500 && value <= 2000) {
        return 500;
    }

    return 1000;
};
// #endregion
